import api from './index'

export function getProductLabels(params) {
  return api.get('/api/v1/product-labels', { params })
}

export function createProductLabel(data) {
  return api.post('/api/v1/product-labels', data)
}

export function updateProductLabel(productLabelCode, data) {
  return api.put(`/api/v1/product-labels/${productLabelCode}`, data)
}

export function deleteProductLabel(productLabelCode) {
  return api.delete(`/api/v1/product-labels/${productLabelCode}`)
}
